import http from '../http-common';
import store from '@/store';

class Logout {
  static expireSession() {
    return http.post(
      '../../selfcare/expireSession',
      {
        agentId: store.state.sessionPayload.agentId,
        lang: store.state.sessionPayload.lang,
        mode: store.state.sessionPayload.mode,
        service: '',
        token: token,
        trkrid: '',
        udf1: '',
        udf2: '',
      },
      {
        headers: {
          Authorization: 'Basic YWRtaW46Z09Wb24/NlFGKA==',
        },
      }
    );
  }
}

export default Logout;
